import { BehaviorSubject } from 'rxjs'

export class ResourceObservable<T> extends BehaviorSubject<T> {}
